import { Skeleton } from '@teach/ui'

/** Скелет строк «Расхода» — той же высоты, что настоящая строка (миниатюра 44px + отступы). */
export const HistorySkeleton = ({ rows = 6 }: { rows?: number }) => (
  <div className="space-y-1">
    {Array.from({ length: rows }, (_, i) => (
      <Skeleton key={i} className="h-[68px] w-full rounded-lg" />
    ))}
  </div>
)
